import * as React from "react"
import { useTracker } from "@modules/analytics"
import { useToggleMerlinPullRequestsSourcing } from "../hooks/useToggleMerlinPullRequestsSourcing"
import {
  siteBuildsSettings as text,
  ui as uiText,
} from "@modules/locales/default.js"
import { Link, Spacer, ToggleCheckbox, Badge } from "gatsby-interface"
import { FormattedMessage } from "@modules/locales"
import { MdInfoOutline, MdArrowForward } from "react-icons/md"
import { useSiteDependencyInfo } from "../hooks/useSiteDependencyInfo"

export type EnableMerlinPullRequestsSourcingProps = {
  siteId: string
  enabled: boolean
}

export function EnableMerlinPullRequestsSourcing({
  siteId,
  enabled,
}: EnableMerlinPullRequestsSourcingProps) {
  const [
    toggleMerlinPullRequestsSourcingEnabled,
    { errorAlert },
  ] = useToggleMerlinPullRequestsSourcing(siteId)
  const { trackButtonClicked } = useTracker()
  const { isCompatibleGatsbyVersion } = useSiteDependencyInfo(
    siteId,
    ">=4.20.0"
  )

  const readMoreLink = `https://gatsbyjs.notion.site/Accelerated-Sourcing-90350db9340444f9ac149dd454970ed8` // @todo add real link

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-merlin-pull-request-checkbox"
        label={
          <React.Fragment>
            {text.labels.enableMerlinPullRequestSourcing}
            <Spacer direction="horizontal" size={3} />
            <Link href={readMoreLink}>
              <MdInfoOutline />
            </Link>
            <Spacer direction="horizontal" size={3} />
            <Badge tone="SUCCESS" size="S" textVariant="DEFAULT">
              {uiText.labels.beta}
            </Badge>
          </React.Fragment>
        }
        hint={
          <React.Fragment>
            {text.messages.enableMerlinPullRequestSourcing}
            {". "}
            {!isCompatibleGatsbyVersion ? (
              <FormattedMessage
                message={text.messages.merlinSourcingRequiresGatsbyVersion}
                tags={{
                  link: function(content: string) {
                    return (
                      <Link to={readMoreLink} variant="SIMPLE">
                        {content} <MdArrowForward />
                      </Link>
                    )
                  },
                }}
              />
            ) : (
              text.messages.merlinSourcingDefaultBanner
            )}
          </React.Fragment>
        }
        checked={!!enabled}
        onChange={() => {
          trackButtonClicked(`update merlin pull request sourcing`, {
            uiSource: `Site Settings`,
          })
          toggleMerlinPullRequestsSourcingEnabled()
        }}
        disabled={!isCompatibleGatsbyVersion}
      />
      {errorAlert}
    </React.Fragment>
  )
}
